<template>
  <div>
    <v-dialog max-width="500">
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          color="surface-variant"
          text="Add new ticket"
          variant="flat"
        ></v-btn>
      </template>

      <template v-slot:default="{ isActive }">
        <v-card
          flat
          width="500"
          :style="{
            borderBottom: '3px solid #272727',
            borderLeft: '1px solid #272727',
            borderTop: '1px solid #272727',
            borderRight: '3px solid #272727',
            borderRadius: '8px',
          }"
        >
          <v-sheet
            class="d-flex justify-center align-center py-2"
            color="accent"
            style="font-size: 10pt; font-weight: 600"
          >
            Add new ticket
          </v-sheet>
          <v-divider class="primary"></v-divider>
          <div class="pa-4">
            <v-text-field
              label="Title"
              variant="solo"
              bg-color="smokeDark"
              flat
              v-model="title"
            ></v-text-field>
            <v-textarea
              label="Description"
              variant="solo"
              flat
              bg-color="smokeDark"
              v-model="description"
            ></v-textarea>
          </div>
          <v-divider> </v-divider>
          <v-card-actions>
            <v-btn text="Close" @click="isActive.value = false"></v-btn>

            <v-spacer></v-spacer>
            <v-btn color="button" variant="flat" @click="save(isActive)"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
    }),
  },
  data() {
    return {
      title: "",
      description: "",
    };
  },
  methods: {
    save(isActive) {
      this.$store.dispatch("addTicket", {
        title: this.title,
        description: this.description,
      });
      this.title = "";
      this.description = "";
      if (isActive && "value" in isActive) {
        isActive.value = false;
      }
    },
  },
};
</script>
